import { Icons } from '@/components/icons';
import { Button } from '@/components/primitives/Button';
import {
  PopoverContent,
  PopoverItem,
  PopoverRoot,
  PopoverTrigger,
} from '@/components/primitives/Popover';
import { Typography } from '@/components/primitives/Typography';
import { setTenant } from '@/features/configuration/configurationActions';
import { tenantSelector } from '@/features/configuration/configurationSelector';
import { useDispatch, useSelector } from '@/store/utils';
import type { TenantOption } from '@/types/tenant';
import { TENANT_OPTIONS } from '@/utils/tenant';

const TenantSelect = () => {
  const selectedTenant = useSelector(tenantSelector);
  const dispatch = useDispatch();

  const handleTenantChange = (tenant: TenantOption) => {
    dispatch(setTenant(tenant));
  };

  return (
    <PopoverRoot>
      <PopoverTrigger asChild>
        <Button variant="ghostLink" data-testid="tenant-select-trigger">
          <Icons.powerSocket width={24} height={24} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-40" align="end" side="bottom">
        {TENANT_OPTIONS.map((option) => (
          <PopoverItem
            key={option.value}
            active={option.value === selectedTenant.value}
            onClick={() => handleTenantChange(option)}
            data-testid={`tenant-select-item-${option.value}`}
          >
            <Typography variant="body1">{option.label}</Typography>
            {option.value === selectedTenant.value && (
              <Icons.checkCircle
                height={16}
                width={16}
                className="text-success-text"
              />
            )}
          </PopoverItem>
        ))}
      </PopoverContent>
    </PopoverRoot>
  );
};

export default TenantSelect;
